import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: string;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: undefined,
};

const postFormEditPersonalInformationSlice = createSlice({
  name: "postFormEditPersonalInformation",
  initialState,
  reducers: {
    postFormEditPersonalInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    postFormEditPersonalInformationSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    postFormEditPersonalInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetFormEditPersonalInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  postFormEditPersonalInformationStart,
  postFormEditPersonalInformationSuccess,
  postFormEditPersonalInformationFailed,
  resetFormEditPersonalInformation,
} = postFormEditPersonalInformationSlice.actions;

export default postFormEditPersonalInformationSlice.reducer;
